import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_de884c62: FaireBrandEntity = {
  token: "b_de884c62",
  type: "brand",
  name: "E. Frances Paper",
  avatarUrl:
    "https://cdn.faire.com/fastly/dee13de39b286addb0a3002377c78d2ba284b140711e4f1162993f7aa9810b3a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/05e777b8da00be673b4976084a78e0028ae83c1fec424423714dfef175bd6e7e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dee13de39b286addb0a3002377c78d2ba284b140711e4f1162993f7aa9810b3a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05e777b8da00be673b4976084a78e0028ae83c1fec424423714dfef175bd6e7e.png",
  location: "Newport, RI, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 322,
  isTopShop: true,
  isInsider: true,
  description:
    "Illustrations that make you stare, unexpected words that make you laugh, overwhelming feelings of connection and nostalgia and pure, positive joy... that's what E. Frances is all about. Based in Newport, RI, and run by a cousin and two sisters, the E. Frances team LOVES thinking that all the cards they make and sell means all those happy recipients on the other end!",
  meta: {
    source: "api",
    importedAt: "2026-06-04T00:13:28.837Z",
    importedBy: "entity-db-cli",
  },
};
